import { useMemo } from 'react';
import { Extensions } from '@tiptap/core';
import Document from '@tiptap/extension-document';

import useClientCommonTiptapEditorExtensions from '../../../components/tiptapEditor/useClientCommonTiptapEditorExtensions';
import type { SaveTiptapEditorContentFunction } from '../../../../common/tiptap/extensions/externalStoreSync/externalStoreSynchroniserTypes';

type Props = {
    isEditable: boolean;
    saveContent?: SaveTiptapEditorContentFunction;
};

const useTableCellTiptapExtensions = ({ isEditable, saveContent }: Props): Extensions => {
    const commonExtensions = useClientCommonTiptapEditorExtensions({ isEditable, saveContent });

    return useMemo(() => [Document, ...commonExtensions] as Extensions, [commonExtensions]);
};

export default useTableCellTiptapExtensions;
